export default __webpack_public_path__ + "static/media/943.2f86852e.gif";